module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.227daf51.jpeg";